import React from 'react'
import GeoRTELanding from './components/GeoRTELanding'

function App() {
  return <GeoRTELanding />
}

export default App
